import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import VueTelInput from 'vue-tel-input'
import * as Sentry from '@sentry/vue'
import { createSentryPiniaPlugin } from '@sentry/vue'
import { version } from '../package.json'
import { ignoredErrors, piniaStateTransformer } from './sentry'
//import posthogPlugin from './plugins/posthog.ts'

import 'material-icons/iconfont/material-icons.css'
import 'vue-tel-input/vue-tel-input.css'
import './styles.css'
const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://046f4de44eb3cc2f54681b0b5a5d2212@o73332.ingest.us.sentry.io/4509726315839488',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  release: version,
  ignoreErrors: ignoredErrors,
  // Session Replay
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
  normalizeDepth: 4,
  enabled: import.meta.env.VITE_NODE_ENV == 'production',
})

const pinia = createPinia()

pinia.use(createSentryPiniaPlugin({ stateTransformer: piniaStateTransformer }))

app.use(pinia)
app.use(VueTelInput, {
  inputOptions: {
    showDialCode: true,
  },
})
//app.use(posthogPlugin)
app.mount('#app')
